import WebinarsScreen from './containers/webinarsScreen'

export {default as WebinarsScreenLayout} from './components/webinarsScreenLayout'

export default WebinarsScreen
